import React from "react";

export default function SoftauthExamples() {
  const fastapiSetup = `pip install softauth
# add to your FastAPI app
from softauth.fastapi import AuthManager, require_roles

auth = AuthManager(secret="your-secret-key")`;

  const loginCurl = `curl -X POST http://localhost:8000/login \\
  -H "Content-Type: application/json" \\
  -d '{"username":"alice","password":"secret"}'`;

  const loginOutput = `{
  "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
  "token_type": "bearer"
}`;

  const protectedCurl = `curl http://localhost:8000/protected \\
  -H "Authorization: Bearer YOUR_TOKEN_HERE"`;

  const protectedOutput = `{
  "hello": "alice"
}`;

  const adminCurl = `curl http://localhost:8000/admin-only \\
  -H "Authorization: Bearer YOUR_TOKEN_HERE"`;

  const adminOutput = `# if token has "roles": ["admin"]
{ "admin": true }

# if token is missing the role
{ "detail": "Forbidden: missing required role" }`;

  const flaskExample = `from flask import Flask
from softauth.flask import AuthManager, login_required, role_required

app = Flask(__name__)
auth = AuthManager(app, secret="your-secret-key")

@app.post("/login")
def login():
    token = auth.create_token({"sub": "bob", "roles": ["editor"]})
    return {"access_token": token}

@app.get("/dashboard")
@login_required
def dashboard():
    return {"user": "bob"}`;

  return (
    <main className="docs-wrap">
      <div className="docs-layout">
        <aside className="docs-toc">
          <strong>On this page</strong>
          <a href="#setup">Setup</a>
          <a href="#login">Login & Token</a>
          <a href="#protected">Protected Route</a>
          <a href="#roles">Role Guard</a>
          <a href="#flask">Flask Example</a>
        </aside>

        <article>
          <header className="stt-hero">
            <div className="stt-pill">softauth • Examples</div>
            <h1 className="stt-h1">JWT auth in minutes</h1>
            <p className="stt-lead">Install, wire up, and hit protected endpoints right away.</p>
          </header>

          <section id="setup" className="stt-section stt-card">
            <h2 className="stt-card-title">Setup</h2>
            <div className="stt-card-body">
              <div className="stt-code"><pre className="stt-pre">{fastapiSetup}</pre></div>
            </div>
          </section>

          <section id="login" className="stt-section stt-card">
            <h2 className="stt-card-title">Login & Token</h2>
            <div className="stt-card-body">
              <div className="stt-code"><pre className="stt-pre">{loginCurl}</pre></div>
              <div className="stt-output"><pre className="stt-pre">{loginOutput}</pre></div>
            </div>
          </section>

          <section id="protected" className="stt-section stt-card">
            <h2 className="stt-card-title">Protected Route</h2>
            <div className="stt-card-body">
              <div className="stt-code"><pre className="stt-pre">{protectedCurl}</pre></div>
              <div className="stt-output"><pre className="stt-pre">{protectedOutput}</pre></div>
            </div>
          </section>

          <section id="roles" className="stt-section stt-card">
            <h2 className="stt-card-title">Role Guard</h2>
            <div className="stt-card-body">
              <div className="stt-code"><pre className="stt-pre">{adminCurl}</pre></div>
              <div className="stt-output"><pre className="stt-pre">{adminOutput}</pre></div>
            </div>
          </section>

          <section id="flask" className="stt-section stt-card">
            <h2 className="stt-card-title">Flask Example</h2>
            <div className="stt-card-body">
              <div className="stt-code"><pre className="stt-pre">{flaskExample}</pre></div>
            </div>
          </section>
        </article>
      </div>
    </main>
  );
}
